"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.instructions = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const taskSetup_1 = require("../../taskSetup");
const __1 = require("../../..");
const helpers_1 = require("../../shared/helpers");
const taskStore_1 = require("../../../taskStore");
const instructionData = [
    {
        prompt: 'generalIntro1',
        image: 'avatarOwl', // GIF?
        buttonText: 'continueButtonText',
    },
    // prompt: 'generalIntro2', // "First, you get to choose a buddy to play along with you. ..."
    // prompt: 'generalIntro3', // "Now that you have your buddy, we want to explain how the games work."
    // prompt: 'pickBuddy',
    // images: ['avatar_owl', 'avatar_cat', 'avatar_penguin'],
    {
        prompt: 'generalIntro4',
        image: 'avatarOwl', // ToDo: replay button with arrow?
        buttonText: 'continueButtonText',
    },
    {
        prompt: 'generalIntro5',
        image: 'avatarOwl',
        buttonText: 'continueButtonText',
    },
];
// additional keyboard instructions for those not using a tablet
if (!taskSetup_1.isTouchScreen) {
    instructionData.push({
        prompt: 'generalKeyboardInstructions',
        image: 'avatarOwl',
        buttonText: 'continueButtonText',
    });
}
exports.instructions = instructionData.map((data) => {
    return {
        type: plugin_html_multi_response_1.default,
        stimulus: () => {
            const t = (0, taskStore_1.taskStore)().translations;
            return `
        <div class="lev-stimulus-container">
            ${(0, helpers_1.getParticipantUtilityButtonsHtml)('replay-btn-revisited')}
            <div class="lev-row-container instruction-small">
                <p>${t[data.prompt]}</p>
            </div>
            <div class="lev-stim-content-x-3">
                <img
                  src=${__1.mediaAssets.images[data.image]}
                  alt='Instruction graphic'
                />
            </div>
        </div>
      `;
        },
        prompt_above_buttons: true,
        button_choices: ['Next'],
        button_html: () => {
            const t = (0, taskStore_1.taskStore)().translations;
            return [
                `<button class="primary">
                ${t[data.buttonText]}
            </button>`,
            ];
        },
        keyboard_choices: 'NO_KEYS',
        on_load: () => {
            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[data.prompt]);
            const pageStateHandler = new helpers_1.PageStateHandler(data.prompt, true);
            (0, helpers_1.setupReplayAudio)(pageStateHandler);
            (0, helpers_1.addExperimenterButtons)();
            (0, helpers_1.setupFullscreenButton)();
        },
        on_finish: () => {
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
                assessment_stage: 'instructions',
            });
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
        },
    };
});
